<template>
    <file-upload
        :src="data?.url ?? data?.external_url ?? null"
        :path="data?.path ?? null"
        :no_src="no_src"
        :accept="accept"
        :title="title"
        :name="name"
        :size="size"
        :upload_url="options.file_upload_url"
        :delete_url="options.file_delete_url"
        :additional_data="{resource_id: unique_id}"
        @upload:done="uploadDone"
        @delete:done="deleteDone"
        ref="fileUploader"
    >
        <template v-if="$slots.empty_placeholder" v-slot:empty_placeholder>
            <slot name="empty_placeholder"></slot>
        </template>
        <template v-if="$slots.uploaded_placeholder" v-slot:uploaded_placeholder>
            <slot name="uploaded_placeholder"></slot>
        </template>
        <template v-if="allow_external_url" v-slot:custom_actions>
            <modal title="External Link" size="small" name="partnero_resource_ext_url_modal" @modalClose="onCancel">
                <template #toggle>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-500 hover:text-gray-900 cursor-pointer" title="External link">
                        <path d="M1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811L7 21C3.64378 20.7257 1 17.9216 1 14.5ZM16.8483 18.9868C19.1817 18.8093 21 16.8561 21 14.5C21 12.927 20.1884 11.4962 18.8771 10.6781L18.0714 10.1754L17.9517 9.23338C17.5735 6.25803 15.0288 4 12 4C8.97116 4 6.42647 6.25803 6.0483 9.23338L5.92856 10.1754L5.12288 10.6781C3.81156 11.4962 3 12.927 3 14.5C3 16.8561 4.81833 18.8093 7.1517 18.9868L7.325 19H16.675L16.8483 18.9868ZM13 13V17H11V13H8L12 8L16 13H13Z"></path>
                    </svg>
                </template>
                <template #body>
                    <div>
                        <text-field
                            v-model="external_url"
                            label="URL"
                            type="text"
                        >
                        </text-field>

                    </div>
                </template>
                <template #footer>
                    <btn @click="onExternalUrlSave">Save</btn>
                </template>

            </modal>
        </template>
    </file-upload>
</template>

<script>
export default {
    props: ['unique_id', 'data', 'options', 'name', 'title', 'no_src', 'accept', 'allow_external_url', 'size'],
    data() {
        return {
            external_url: this.data.external_url
        }
    },
    methods: {
        uploadDone(data) {
            this.data.url = data[this.name].url;
            this.data.path = data[this.name].path;

            this.removeExternalUrl()
        },
        deleteDone(done) {
            if (done) {
                this.data.url = null;
                this.data.path = null;
            }
            this.removeExternalUrl()
        },
        onExternalUrlSave() {
            this.data.external_url = this.external_url
            this.emitter.emit('modal-off', 'partnero_resource_ext_url_modal')
        },
        removeExternalUrl() {
            this.external_url = null;
            this.data.external_url = this.external_url
        },
        onCancel(name) {
            if (name !== null && name === 'partnero_resource_ext_url_modal') {
                this.external_url = this.data.external_url;
            }
        }
    }
}
</script>

<style lang="scss"></style>
